export enum TAGS_PERMISSIONS {
  TAGS_VIEW = 'PRODUCT_TAGVIEW',
  TAGS_WRITE = 'PRODUCT_TAGWRITE',
}
